module.exports = __webpack_public_path__ + "img/patient-enrollment-gray.1170677a.svg";